import { Helmet } from "react-helmet-async";
import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { Services } from "@/components/landing/Services";
import { Portfolio } from "@/components/landing/Portfolio";
import { Contact } from "@/components/landing/Contact";
import { Footer } from "@/components/landing/Footer";
import { FallingLeaves } from "@/components/landing/FallingLeaves";

export default function Landing() {
  return (
    <>
      <Helmet>
        <title>786 Interactive — Islamic Web &amp; App Development | 786i.net</title>
        <meta
          name="description"
          content="786 Interactive builds web and mobile applications for the Islamic world — prayer companions, e-learning madrasahs, halal directories, zakat tools and bespoke platforms. Bismillah, we build."
        />
        <meta
          name="keywords"
          content="Islamic web development, Muslim app developer, Islamic mobile app, prayer app development, Quran app, halal directory, zakat calculator, Islamic e-learning, masjid app, 786 Interactive, 786i.net"
        />
        <link rel="canonical" href={`${window.location.origin}/`} />
        <meta property="og:title" content="786 Interactive — Islamic Web &amp; App Development" />
        <meta property="og:description" content="Prayer companions, e-learning madrasahs, halal directories and bespoke platforms — crafted with ihsan for the Ummah." />
        <meta property="og:url" content={`${window.location.origin}/`} />
        <meta property="og:type" content="website" />
        <meta name="twitter:title" content="786 Interactive — Islamic Web &amp; App Development" />
        <meta name="twitter:description" content="Prayer companions, e-learning madrasahs, halal directories and bespoke platforms — crafted with ihsan for the Ummah." />
      </Helmet>
      <main data-testid="landing-page" className="bg-[#F7F6F1] text-[#122A1D] overflow-x-hidden">
        <FallingLeaves />
        <Header />
        <Hero />
        <Services />
        <Portfolio />
        <Contact />
        <Footer />
      </main>
    </>
  );
}
